module.exports = __webpack_public_path__ + "img/ifaw.f3c63d6.png";